<div class="profile-container">
    <div class="profile-content">
        <div class="personal-details">

            <div class="header-block">
                <div class="header-title">
                    <app-breadcrumb></app-breadcrumb>
                </div>
                <div class="add-block">
                    <div class="search">
                        <form autocomplete="off">
                            <input type="text" placeholder="search" (keyup.enter)="getCompanyInfoByWildSearch()"
                                [ngModelOptions]="{standalone: true}" [(ngModel)]="searchFilter">
                        </form>
                        <i class="bi bi-search" (click)="getCompanyInfoByWildSearch()"></i>
                    </div>
                    <button title="Add" data-toggle="modal" data-target="#exampleModal"><i class="bi bi-plus-lg"></i> {{
                        'generic.add' | translate
                        }}</button>
                    <div class="filter-icon">
                        <i class="bi bi-arrow-clockwise" title="Refresh" (click)="refreshAll()"></i>
                    </div>
                </div>
            </div>

            <table class="table table-striped">
                <thead>
                    <tr>
                        <th class="w-15">Company Info Id</th>
                        <th class="w-20">Company Name</th>
                        <th class="w-15">Email Id</th>
                        <th class="w-20">Phone Number</th>
                        <th class="w-20">Industry</th>
                        <th class="action-th">{{ 'generic.action' | translate
                            }}</th>
                    </tr>
                </thead>
            </table>
            <div *ngIf="!isLoading">
                <div class="data-view" id="{{company.id}}" [ngClass]="{ 'delete-highlight': company.id == recordId }"
                    *ngFor="let company of filteredCompanyInfoData | paginate : {
                    itemsPerPage: tableSize,
                    currentPage: pageNumber,
                    totalItems: totalRecords
                    }  ;let i = index">
                    <p class="w-15">{{company.companyInfoId || " -- " }}</p>

                    <p class="w-20">{{company.companyName || " -- " }}</p>
                    <p class="w-15">{{company.bOEmail || " -- " }}</p>
                    <p class="w-20">{{company.bOPhNo || " -- " }}</p>
                    <p class="w-20">{{ getIndustryViewValue(company.bOIndustry) }}</p>

                    <p class="action-buttons action-td">
                        <i data-toggle="modal" title="Add User" *ngIf="!company.userCreated"
                            (click)="openAddUserModal(company)" data-target="#addUserModal"
                            class="bi bi-person-plus-fill"></i>
                        <i data-toggle="modal" title="Add App Properties" (click)="openPropertiesModal(company)"
                            data-target="#propertiesModal" class="bi bi-plus-lg"></i>
                        <i data-toggle="modal" title="View" (click)="viewCompanyInfoById(company)"
                            data-target="#viewModal" class="bi bi-eye-fill"></i>
                        <i title="Delete" class="bi bi-trash3" (click)="deleteIdSelect(company.id,company)"
                            data-toggle="modal" data-target="#deleteModal"></i>
                    </p>
                </div>
            </div>

            <div class="loader" *ngIf="isLoading">
                <div class="spinner"></div>
            </div>

            <div class="loader" *ngIf="!isLoading && filteredCompanyInfoData.length == 0">
                <div class="no-data">
                    <img src="assets/no-data-6.png" alt="">
                    <p>no data found</p>
                </div>
            </div>

            <div class="paginator">
                <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize"
                    [totalRecords]="totalRecords" [showFirstLastIcon]="false" [showCurrentPageReport]="true"
                    currentPageReportTemplate="{first} - {last} of {totalRecords}">
                </p-paginator>
            </div>

        </div>
    </div>
</div>

<div class="modal fade" id="deleteModal" tabindex="-1" aria-labelledby="deleteModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="deleteModalLabel">{{ 'generic.confirmation' | translate }}
                    <span data-dismiss="modal">
                        <i class="bi bi-x-lg" (click)="clearData()"></i>
                    </span>
                </h5>
            </div>
            <div class="modal-body">
                <p>{{ 'generic.deleteText' | translate }} <span class="delete-span">“{{recordName}}”</span>?</p>
                <div class="modal-footer">
                    <button type="button" id="closeModalButton1" (click)="clearData()" class="btn btn-secondary"
                        data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
                    <button type="button" (click)="deleteCompanyInfo()" class="btn btn-primary">{{ 'generic.delete' |
                        translate }}</button>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg modal-lg-custom">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Add Company Info
                    <span data-dismiss="modal">
                        <i class="bi bi-x-lg" (click)="closePopUp()"></i>
                    </span>
                </h5>
            </div>
            <div class="modal-body modal-body-scroll">
                <div [formGroup]="companyInfoForm">
                    <div class="row">
                        <div class="col-md-12 mb-3">
                            <h5 class="section-title">Basic Information</h5>
                            <hr>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Company Name <span class="required">*</span></label>
                                <input formControlName="companyName" type="text" class="form-control">
                                <span class="err"
                                    *ngIf="companyInfoForm.get('companyName').invalid && formSubmit">Company Name
                                    required</span>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>BO Name <span class="required">*</span></label>
                                <input formControlName="boname" type="text" class="form-control">
                                <span class="err" *ngIf="companyInfoForm.get('boname').invalid && formSubmit">BO Name
                                    required</span>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>BO Phone Number <span class="required">*</span></label>
                                <input formControlName="bophNo" type="number" class="form-control">
                                <span class="err" *ngIf="companyInfoForm.get('bophNo').invalid && formSubmit">BO Phone
                                    Number required</span>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>BO Email <span class="required">*</span></label>
                                <input formControlName="boemail" type="text" class="form-control">
                                <span class="err" *ngIf="companyInfoForm.get('boemail').invalid && formSubmit">Valid BO
                                    Email required</span>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>BO Industry <span class="required">*</span></label>
                                <select formControlName="boindustry" class="form-control">
                                    <option value="" disabled selected>Select Industry</option>
                                    <option *ngFor="let industry of industryTypes" [value]="industry.value">
                                        {{ industry.viewValue }}
                                    </option>
                                </select>
                                <span class="err" *ngIf="companyInfoForm.get('boindustry').invalid && formSubmit">BO
                                    Industry required</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" id="closeModalButton2" (click)="closePopUp()" class="btn btn-secondary"
                        data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
                    <button type="button" (click)="addCompanyInfo()" class="btn btn-primary">{{ 'generic.add' |
                        translate
                        }}</button>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="modal fade" id="viewModal" tabindex="-1" aria-labelledby="viewModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg modal-lg-custom">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="viewModalLabel">View Company Info
                    <span class="header-action">
                        <span data-dismiss="modal">
                            <i class="bi bi-x-lg cursor-pointer" (click)="closePopUp()"></i>
                        </span>
                        <ng-container *ngIf="singleCompanyInfoData && singleCompanyInfoData.length > 0">
                            <i *ngIf="singleCompanyInfoData[0].isBlocked" title="Unblock" class="bi bi-unlock-fill text-success cursor-pointer" style="margin-right: 15px;" (click)="updateBlockStatus(singleCompanyInfoData[0].companyInfoId, false)"></i>
                            <i *ngIf="!singleCompanyInfoData[0].isBlocked" title="Block" class="bi bi-lock-fill text-danger cursor-pointer" style="margin-right: 15px;" (click)="updateBlockStatus(singleCompanyInfoData[0].companyInfoId, true)"></i>
                        </ng-container>
                    </span>
                </h5>
            </div>
            <div class="modal-body modal-body-scroll">
                <div class="loader" *ngIf="isActionLoading">
                    <div class="spinner"></div>
                </div>
                <div *ngIf="!isActionLoading">
                    <div class="service-data" *ngFor="let viewData of singleCompanyInfoData">
                        <div class="form-group">
                            <div class="row">
                                <div class="col-md-12 mb-3">
                                    <h5 class="section-title">Basic Information</h5>
                                    <hr>
                                </div>
                                <div class="col-md-6 col-lg-6 mb-3">
                                    <label class="label-fw-500">Company Info Id :</label>
                                    <p>{{viewData.companyInfoId || '--'}}</p>
                                </div>
                                <div class="col-md-6 col-lg-6 mb-3">
                                    <label class="label-fw-500">Company Name :</label>
                                    <p>{{viewData.companyName || '--'}}</p>
                                </div>
                                <div class="col-md-6 col-lg-6 mb-3">
                                    <label class="label-fw-500">BO Name :</label>
                                    <p>{{viewData.bOName || '--'}}</p>
                                </div>
                                <div class="col-md-6 col-lg-6 mb-3">
                                    <label class="label-fw-500">BO Phone Number :</label>
                                    <p>{{viewData.bOPhNo || '--'}}</p>
                                </div>
                                <div class="col-md-6 col-lg-6 mb-3">
                                    <label class="label-fw-500">BO Email :</label>
                                    <p>{{viewData.bOEmail || '--'}}</p>
                                </div>
                                <div class="col-md-6 col-lg-6 mb-3">
                                    <label class="label-fw-500">BO Industry :</label>
                                    <p>{{ getIndustryViewValue(viewData.bOIndustry) }}</p>
                                </div>
                            </div>

                            <div class="row" *ngIf="viewData.keyValuePair && viewData.keyValuePair.length > 0">
                                <div class="col-md-12 mt-3-mb-1">
                                    <h5 class="section-title">Specifications</h5>
                                    <hr>
                                </div>
                                <div class="col-md-6 col-lg-6 mb-3" *ngFor="let kv of viewData.keyValuePair">
                                    <label class="label-fw-500">{{ getLabel(kv.key) }} :</label>
                                    <p class="word-break-all">{{kv.value || '--'}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="closePopUp()">{{
                    'generic.close' | translate }}</button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="propertiesModal" tabindex="-1" aria-labelledby="propertiesModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg modal-lg-custom">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="propertiesModalLabel">Add App Properties Config
                    <span data-dismiss="modal">
                        <i class="bi bi-x-lg" (click)="closePopUp()"></i>
                    </span>
                </h5>
            </div>
            <div class="modal-body modal-body-scroll">
                <div class="loader" *ngIf="isActionLoading">
                    <div class="spinner"></div>
                </div>
                <div *ngIf="!isActionLoading">
                    <div [formGroup]="appPropertiesForm">
                        <div class="row">
                            <div class="col-md-12 mb-3">
                                <div class="d-flex align-items-center">
                                    <h5 class="section-title-m0 mr-3">App Properties</h5>
                                    <select class="form-control" style="width: auto; min-width: 200px;"
                                        *ngIf="!selectedCompanyIsAppConfig" [(ngModel)]="selectedCompanyInfo"
                                        [ngModelOptions]="{standalone: true}"
                                        (change)="getProperties(selectedCompanyInfo)">
                                        <option *ngFor="let company of filteredCompanyInfoData" [ngValue]="company">
                                            {{company.companyName}}</option>
                                    </select>
                                </div>
                                <hr>
                            </div>
                            <ng-container formArrayName="keyValuePair">
                                <div class="col-md-6" *ngFor="let kvp of appKeyValuePair.controls; let i = index"
                                    [formGroupName]="i">
                                    <div class="form-group">
                                        <label>
                                            {{ kvp.get('label')?.value }}
                                            <span *ngIf="selectedCompanyIsAppConfig" class="ml-5">
                                                <i *ngIf="!kvp.get('isEditMode')?.value"
                                                    class="bi bi-pencil cursor-pointer-primary"
                                                    (click)="editProperty(i)" title="Edit"></i>
                                                <ng-container *ngIf="kvp.get('isEditMode')?.value">
                                                    <i class="bi bi-x-lg text-danger cursor-pointer-mr-5"
                                                        (click)="cancelEditProperty(i)" title="Cancel"></i>
                                                    <i class="bi bi-check-lg text-success cursor-pointer"
                                                        (click)="submitProperty(i)" title="Submit"></i>
                                                </ng-container>
                                            </span>
                                        </label>
                                        <input formControlName="value" type="text" class="form-control"
                                            [readonly]="selectedCompanyIsAppConfig && !kvp.get('isEditMode')?.value">
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" id="closeModalButton3" (click)="closePopUp()" class="btn btn-secondary"
                    data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
                <button *ngIf="!selectedCompanyIsAppConfig" type="button" (click)="saveAppProperties()"
                    class="btn btn-primary">{{ 'generic.save' |
                    translate }}</button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="addUserModal" tabindex="-1" aria-labelledby="addUserModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="addUserModalLabel">Add Business Owner
                    <span data-dismiss="modal">
                        <i class="bi bi-x-lg" id="closeUserModalButton"></i>
                    </span>
                </h5>
            </div>
            <div class="modal-body">
                <div [formGroup]="userForm">
                    <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-12">
                            <div class="form-group">
                                <label>{{ 'users.userName' | translate }} <span class="required-field">*</span></label>
                                <input formControlName="userName" type="text" class="form-control">
                                <span class="err" *ngIf="userForm.get('userName').invalid && userFormSubmit">user name
                                    required</span>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12">
                            <div class="form-group">
                                <label>{{ 'users.userMobileNo' | translate }} <span
                                        class="required-field">*</span></label>
                                <input formControlName="userMobileNo" type="number" class="form-control">
                                <span class="err" *ngIf="userForm.get('userMobileNo').invalid && userFormSubmit">user
                                    mobile required and should be 10 digits</span>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12">
                            <div class="form-group">
                                <label>{{ 'users.userEmail' | translate }} <span class="required-field">*</span></label>
                                <input formControlName="userEmail" type="email" class="form-control">
                                <span class="err"
                                    *ngIf="userForm.get('userEmail').errors?.required && userFormSubmit">user email
                                    required</span>
                                <span class="err"
                                    *ngIf="userForm.get('userEmail').errors?.pattern && userFormSubmit">valid user email
                                    required</span>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12">
                            <div class="form-group">
                                <label>{{ 'users.password' | translate }} <span class="required-field">*</span></label>
                                <input formControlName="password" type="password" class="form-control">
                                <span class="err" *ngIf="userForm.get('password').invalid && userFormSubmit">user
                                    password required</span>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12">
                            <div class="form-group">
                                <label>{{ 'users.userType' | translate }} <span class="required-field">*</span></label>
                                <input formControlName="userType" readonly="true" type="text" class="form-control">
                                <span class="err" *ngIf="userForm.get('userType').invalid && userFormSubmit">user type
                                    required</span>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12">
                            <div class="form-group">
                                <label>{{ 'users.dashboard' | translate }} <span class="required-field">*</span></label>
                                <ng-multiselect-dropdown [placeholder]="'Select Dashboard'"
                                    [settings]="dashboardDropdownSettings" [data]="dashboardList"
                                    [(ngModel)]="dashboardSelectedList" class="form-control p0-border-none"
                                    [ngModelOptions]="{standalone: true}" (onSelect)="onItemSelect($event)"
                                    (onSelectAll)="onSelectAll($event)">
                                </ng-multiselect-dropdown>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12">
                            <div class="form-group">
                                <label class="flex-between">
                                    <span>{{ 'users.location' | translate }} <span
                                            class="required-field">*</span></span>
                                    <i class="bi bi-plus-lg text-primary cursor-pointer"
                                        (click)="openAddLocationModal()" title="Add Location"></i>
                                </label>
                                <ng-multiselect-dropdown [placeholder]="'Select Location'"
                                    [settings]="locationDropdownSettings" [data]="locationList"
                                    [(ngModel)]="locationSelectedList" class="form-control p0-border-none"
                                    [ngModelOptions]="{standalone: true}" (onSelect)="onItemSelect($event)"
                                    (onSelectAll)="onSelectAll($event)">
                                </ng-multiselect-dropdown>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12">
                            <div class="form-group">
                                <label class="flex-between">
                                    <span>{{ 'users.group' | translate }} <span class="required-field">*</span></span>
                                    <i class="bi bi-plus-lg text-primary cursor-pointer"
                                        (click)="openAddGroupModal()" title="Add Group"></i>
                                </label>
                                <ng-multiselect-dropdown [placeholder]="'Select Group'"
                                    [settings]="objectGroupDataDropdownSettings" [data]="objectGroupData"
                                    [(ngModel)]="objectGroupDataSelectedList" class="form-control p0-border-none"
                                    [ngModelOptions]="{standalone: true}" (onSelect)="onItemSelect($event)"
                                    (onSelectAll)="onSelectAll($event)">
                                </ng-multiselect-dropdown>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12">
                            <div class="form-group">
                                <label class="flex-between">
                                    <span>{{ 'users.branch' | translate }} <span class="required-field">*</span></span>
                                    <i class="bi bi-plus-lg text-primary cursor-pointer" (click)="openAddBranchModal()"
                                        title="Add Branch"></i>
                                </label>
                                <ng-multiselect-dropdown [placeholder]="'Select Branch'"
                                    [settings]="branchDropdownSettings" [data]="branchList"
                                    [(ngModel)]="branchSelectedList" class="form-control p0-border-none"
                                    [ngModelOptions]="{standalone: true}" (onSelect)="onItemSelect($event)"
                                    (onSelectAll)="onSelectAll($event)">
                                </ng-multiselect-dropdown>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12">
                            <div class="form-group">
                                <label class="flex-between">
                                    <span>{{ 'users.department' | translate }} <span
                                            class="required-field">*</span></span>
                                    <i class="bi bi-plus-lg text-primary cursor-pointer" (click)="openAddDepartmentModal()"
                                        title="Add Department"></i>
                                </label>
                                <ng-multiselect-dropdown [placeholder]="'Select Department'"
                                    [settings]="departmentDropdownSettings" [data]="departmentList"
                                    [(ngModel)]="departmentSelectedList" class="form-control p0-border-none"
                                    [ngModelOptions]="{standalone: true}" (onSelect)="onItemSelect($event)"
                                    (onSelectAll)="onSelectAll($event)">
                                </ng-multiselect-dropdown>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12">
                            <div class="form-group">
                                <label>{{ 'users.language' | translate }}</label>
                                <select name="" id="" formControlName="language" class="form-control">
                                    <option value="" selected disabled> -- select language --</option>
                                    <option value="{{list.value}}" *ngFor="let list of languages">{{list.label}}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div *ngFor="let list of userParams">
                            <div class="col-lg-6 col-md-6 col-sm-12">
                                <div class="form-group">
                                    <label>{{list.name}}</label>
                                    <input *ngIf="list.boxType == 'Input'" [ngModelOptions]="{standalone: true}"
                                        type="text" [(ngModel)]="list.value" class="form-control">
                                    <select name="" id="" *ngIf="list.boxType == 'Dropdown'"
                                        [ngModelOptions]="{standalone: true}" [(ngModel)]="list.value"
                                        class="form-control">
                                        <option value="" disabled selected hidden>--- Select ---</option>
                                        <option *ngFor="let dropdownList of list.possibleValue" [value]="dropdownList">
                                            {{dropdownList}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">{{ 'generic.cancel' | translate
                    }}</button>
                <button type="button" (click)="saveUser()" *ngIf="buttonDisable == false" class="btn btn-primary">{{
                    'generic.add' | translate }}</button>
            </div>
        </div>
    </div>
</div>
<!-- Hidden buttons for programmatic modal toggles -->
<button type="button" id="openAddLocationModalBtn" style="display:none;" data-toggle="modal" data-target="#addLocationModal"></button>
<button type="button" id="openAddGroupModalBtn" style="display:none;" data-toggle="modal" data-target="#addGroupModal"></button>
<button type="button" id="openAddBranchModalBtn" style="display:none;" data-toggle="modal" data-target="#addBranchModal"></button>
<button type="button" id="openAddDepartmentModalBtn" style="display:none;" data-toggle="modal" data-target="#addDepartmentModal"></button>
<button type="button" id="openAddUserModalBtn" style="display:none;" data-toggle="modal" data-target="#addUserModal"></button>

<!-- Add Location Modal -->
<div class="modal fade" id="addLocationModal" tabindex="-1" data-backdrop="static" aria-labelledby="addLocationModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="addLocationModalLabel">{{ 'location.headings.add' | translate }}
                    <span data-dismiss="modal">
                        <i class="bi bi-x-lg" (click)="closeAddLocationModal()"></i>
                    </span>
                </h5>
            </div>
            <div class="modal-body">
                <div [formGroup]="locationForm">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>{{ 'location.zone' | translate }} <span class="required">*</span></label>
                                <input formControlName="zone" type="text" class="form-control">
                                <span class="err" *ngIf="locationForm.get('zone').invalid && formSubmitLocation">Zone required</span>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>{{ 'location.city' | translate }} <span class="required">*</span></label>
                                <input formControlName="city" type="text" class="form-control">
                                <span class="err" *ngIf="locationForm.get('city').invalid && formSubmitLocation">City required</span>
                            </div>
                        </div>

                        <div class="col-md-6">
                            <div class="form-group">
                                <label>{{ 'location.provinceOrState' | translate }} <span class="required">*</span></label>
                                <input formControlName="provinceOrState" type="text" class="form-control">
                                <span class="err" *ngIf="locationForm.get('provinceOrState').invalid && formSubmitLocation">Province or state required</span>
                            </div>
                        </div>

                        <div class="col-md-6">
                            <div class="form-group">
                                <label>{{ 'location.country' | translate }} <span class="required">*</span></label>
                                <input formControlName="country" type="text" class="form-control">
                                <span class="err" *ngIf="locationForm.get('country').invalid && formSubmitLocation">Country required</span>
                            </div>
                        </div>

                        <div class="col-md-6">
                            <div class="form-group">
                                <label>{{ 'location.postalCode' | translate }} <span class="required">*</span></label>
                                <input formControlName="postalCode" type="text" class="form-control">
                                <span class="err" *ngIf="locationForm.get('postalCode').invalid && formSubmitLocation">Postal/zip code required</span>
                            </div>
                        </div>

                        <div class="col-md-6">
                            <div class="form-group">
                                <label style="visibility: hidden;">Spacer</label>
                                <div class="toggle-switch-wrapper">
                                    <label class="toggle-switch" style="display: inline-block; margin-bottom: 0;">
                                        <input formControlName="stockPoint" type="checkbox" id="exampleCheck1Location">
                                        <span class="toggle-slider"></span>
                                    </label>
                                    <label for="exampleCheck1Location" style="display: inline-block; margin-bottom: 0;">Stock Point</label>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-12">
                            <div class="form-group">
                                <label>{{ 'Users Responsible' }}</label>
                                <ng-multiselect-dropdown [placeholder]="'Select Users'" [settings]="userDropdownSettings"
                                    [data]="userList" [(ngModel)]="userSelectedList"
                                    [ngModelOptions]="{standalone: true}">
                                </ng-multiselect-dropdown>
                                <span class="err" *ngIf="locationForm.get('stockPoint').value && userSelectedList.length == 0 && formSubmitLocation">Please select at least one user when Stock Point is enabled</span>
                            </div>
                        </div>
                    </div>

                    <div class="map-frame mt-3">
                        <div id="mapLocation" style="height: 400px; width: 100%;">
                        </div>
                    </div>

                </div>
                <div class="modal-footer">
                    <button type="button" id="closeAddLocationModalBtn" (click)="closeAddLocationModal()" class="btn btn-secondary"
                        data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
                    <button type="button" (click)="addLocation()" class="btn btn-primary">{{ 'generic.add' | translate
                        }}</button>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Add Group Modal -->
<div class="modal fade" id="addGroupModal" tabindex="-1" data-backdrop="static" aria-labelledby="addGroupModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="addGroupModalLabel">{{ 'object-group-master.headings.add' | translate }}
          <span data-dismiss="modal">
            <i data-dismiss="modal" (click)="closeAddGroupModal()" class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <div [formGroup]="groupForm">
          <div class="row">
            <div class="col-md-12 col-lg-12">
              <label for="">{{ 'object-group-master.groupName' | translate }} <span class="required">*</span></label>
              <input type="text" (keyup.enter)="addObjectGroup()" (keypress)="blockSpecialChars($event)" class="form-control" formControlName="groupName">
            </div>
          </div>
        </div>
      <div class="modal-footer">
        <button type="button" id="closeAddGroupModalBtn" class="btn btn-secondary" (click)="closeAddGroupModal()" data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
        <button type="button" (keydown.enter)="addObjectGroup()" (click)="addObjectGroup()" class="btn btn-primary">{{ 'generic.add' | translate }}</button>
      </div>
    </div>
  </div>
  </div>
</div>

<!-- Add Branch Modal -->
<div class="modal fade" id="addBranchModal" tabindex="-1" data-backdrop="static" aria-labelledby="addBranchModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="addBranchModalLabel">{{ 'branch-master.headings.add' | translate }}
          <span data-dismiss="modal">
            <i class="bi bi-x-lg" (click)="closeAddBranchModal()"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <div [formGroup]="branchForm">
          <div class="form-group">
            <div class="row">
              <div class="col-md-6 col-lg-6">
                <label>{{ 'branch-master.name' | translate }} <span class="required">*</span></label>
                <input formControlName="name" type="text" class="form-control">
              </div>
              <div class="col-md-6 col-lg-6">
                <label>{{ 'branch-master.address' | translate }} <span class="required">*</span></label>
                <input formControlName="address" type="text" class="form-control">
              </div>
              <div class="col-md-6 col-lg-6">
                <label>{{ 'branch-master.description' | translate }}</label>
                <input formControlName="description" type="text" class="form-control">
              </div>
              <div class="col-md-6 col-lg-6">
                <label>{{ 'branch-master.latitude' | translate }}</label>
                <input formControlName="latitude" type="text" class="form-control">
              </div>
              <div class="col-md-6 col-lg-6">
                <label>{{ 'branch-master.longitude' | translate }}</label>
                <input formControlName="longitude" type="text" class="form-control">
              </div>
              <div class="col-md-6 col-lg-6">
                <label>{{ 'branch-master.internal' | translate }}</label>
                <select name="" id="" formControlName="internal" class="form-control">
                  <option [ngValue]="true">True</option>
                  <option [ngValue]="false">False</option>
                </select>
              </div>
              <div class="col-md-6 col-lg-6" *ngIf="branchForm.controls['internal'].value == 'false'">
                <label>{{ 'branch-master.belongsToType' | translate }}</label>
                <select name="" id="" formControlName="belongsToType" class="form-control">
                  <option value="Dealer">Dealer</option>
                  <option value="Distributor">Distributor</option>
                </select>
              </div>
              <div class="col-md-6 col-lg-6" *ngIf="branchForm.controls['belongsToType'].value == 'Dealer'">
                <label>{{ 'branch-master.belongsToId' | translate }}</label>
                <select class="form-control" formControlName="belongsToId">
                  <option *ngFor="let list of dealerList" value="{{list.idealerId}}">{{list.name}}</option>
              </select>
              </div>
              <div class="col-md-6 col-lg-6" *ngIf="branchForm.controls['belongsToType'].value == 'Distributor'">
                <label>{{ 'branch-master.belongsToId' | translate }}</label>
                <select class="form-control" formControlName="belongsToId">
                  <option *ngFor="let list of distributorList" value="{{list.idistributorId}}">{{list.name}}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      <div class="modal-footer">
        <button type="button" id="closeAddBranchModalBtn" (click)="closeAddBranchModal()" class="btn btn-secondary" data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
        <button type="button" (click)="addBranch()" class="btn btn-primary">{{ 'generic.add' | translate }}</button>
      </div>
    </div>
  </div>
  </div>
</div>

<!-- Add Department Modal -->
<div class="modal fade" id="addDepartmentModal" tabindex="-1" data-backdrop="static" aria-labelledby="addDepartmentModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="addDepartmentModalLabel">{{ 'department-info.headings.add' | translate }}
            <span data-dismiss="modal">
                <i class="bi bi-x-lg" (click)="closeAddDepartmentModal()"></i>
            </span>
          </h5>
        </div>
        <div class="modal-body">
            <div [formGroup]="departmentForm">
                <div class="form-group">
                    <label>{{ 'department-info.departmentName' | translate }} <span class="required">*</span></label>
                    <input formControlName="departmentName" type="text" class="form-control">
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" id="closeAddDepartmentModalBtn" (click)="closeAddDepartmentModal()" class="btn btn-secondary" data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
                <button type="button" (click)="addDepartment_info()" class="btn btn-primary">{{ 'generic.add' | translate }}</button>
            </div>
        </div>
      </div>
    </div>
</div>
